import React from 'react';
import { motion } from 'framer-motion';
import { Droplets } from 'lucide-react';
export function AnalogySection() {
  return <section className="py-24 bg-amber-900 text-amber-50 overflow-hidden relative" data-id="element-1">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-2"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-3">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-4">
          <div className="inline-block p-4 bg-amber-800 rounded-full mb-6" data-id="element-5">
            <Droplets className="w-8 h-8 text-blue-300" data-id="element-6" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-7">
            Piensa en tu dinero como un balde con agujeros.
          </h2>
          <p className="text-xl text-amber-200" data-id="element-8">
            La mayoría intenta echar más agua. <br data-id="element-9" />
            <span className="text-white font-bold" data-id="element-10">
              Quincena Milagrosa tapa los agujeros primero.
            </span>
          </p>
        </motion.div>

        <div className="bg-amber-950/50 p-8 md:p-12 rounded-3xl border border-amber-800/50 backdrop-blur-sm" data-id="element-11">
          <h3 className="text-2xl font-bold text-center mb-8" data-id="element-12">
            Es como poner semáforos a tu dinero:
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-13">
            <div className="text-center p-6 bg-amber-900/50 rounded-xl border border-amber-800 hover:bg-amber-800/50 transition-colors" data-id="element-14">
              <div className="w-16 h-16 bg-green-500 rounded-full mx-auto mb-4 shadow-[0_0_20px_rgba(34,197,94,0.5)] animate-pulse" data-id="element-15"></div>
              <h4 className="font-bold text-lg mb-2 text-green-400" data-id="element-16">VERDE</h4>
              <p className="text-sm text-amber-200" data-id="element-17">para disfrutar sin culpa</p>
            </div>

            <div className="text-center p-6 bg-amber-900/50 rounded-xl border border-amber-800 hover:bg-amber-800/50 transition-colors" data-id="element-18">
              <div className="w-16 h-16 bg-yellow-500 rounded-full mx-auto mb-4 shadow-[0_0_20px_rgba(234,179,8,0.5)]" data-id="element-19"></div>
              <h4 className="font-bold text-lg mb-2 text-yellow-400" data-id="element-20">
                AMARILLO
              </h4>
              <p className="text-sm text-amber-200" data-id="element-21">para tener cuidado</p>
            </div>

            <div className="text-center p-6 bg-amber-900/50 rounded-xl border border-amber-800 hover:bg-amber-800/50 transition-colors" data-id="element-22">
              <div className="w-16 h-16 bg-red-500 rounded-full mx-auto mb-4 shadow-[0_0_20px_rgba(239,68,68,0.5)]" data-id="element-23"></div>
              <h4 className="font-bold text-lg mb-2 text-red-400" data-id="element-24">ROJO</h4>
              <p className="text-sm text-amber-200" data-id="element-25">para frenar</p>
            </div>
          </div>

          <p className="text-center mt-8 text-xl font-medium text-amber-100" data-id="element-26">
            Dejas de gastar a ciegas.
          </p>
        </div>
      </div>
    </section>;
}